import * as actionTypes from "./actionTypes";

// Shipping Method
export const mallCheckAvailableShippingMethod = data => {
  return {
    type: actionTypes.MALL_CHECK_AVAILABLE_SHIPPING_METHOD,
    data
  };
};

export const mallCheckAvailableShippingMethodSuccess = data => {
  return {
    type: actionTypes.MALL_CHECK_AVAILABLE_SHIPPING_METHOD_SUCCESS,
    data
  };
};

export const mallCheckAvailableShippingMethodFail = () => {
  return {
    type: actionTypes.MALL_CHECK_AVAILABLE_SHIPPING_METHOD_FAIL
  };
};
// END Shipping Method

// Order Summary
export const mallLoadOrderSummary = data => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_SUMMARY,
    data
  };
};

export const mallLoadOrderSummarySuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_SUMMARY_SUCCESS,
    data
  };
};

export const mallLoadOrderSummaryFail = () => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_SUMMARY_FAIL
  };
};
// END Order Summary

// Checkout
export const mallCheckoutOrder = data => {
  return {
    type: actionTypes.MALL_CHECKOUT_ORDER,
    data
  };
};

export const mallCheckoutOrderSuccess = data => {
  return {
    type: actionTypes.MALL_CHECKOUT_ORDER_SUCCESS,
    data
  };
};

export const mallCheckoutOrderFail = data => {
  return {
    type: actionTypes.MALL_CHECKOUT_ORDER_FAIL,
    data
  };
};

export const tempStoreData = data => {
  return {
    type: actionTypes.MALL_TEMP_STORE_DATA,
    data
  };
};

export const clearStoreData = () => {
  return {
    type: actionTypes.MALL_CLEAR_DATA_STORE
  };
};
// END Checkout

// Order List
export const mallLoadOrderList = data => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_LIST,
    data
  };
};

export const mallLoadOrderListSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_LIST_SUCCESS,
    data
  };
};

export const mallLoadOrderListFail = () => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_LIST_FAIL
  };
};
// END Order List

// Order Detail
export const mallLoadOrderDetail = data => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_DETAIL,
    data
  };
};

export const mallLoadOrderDetailSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_DETAIL_SUCCESS,
    data
  };
};

export const mallLoadOrderDetailFail = () => {
  return {
    type: actionTypes.MALL_LOAD_ORDER_DETAIL_FAIL
  };
};
// END Order List

// Complete Order
export const mallCompleteOrder = data => {
  return {
    type: actionTypes.MALL_COMPLETE_ORDER,
    data
  };
};

export const mallCompleteOrderSuccess = () => {
  return {
    type: actionTypes.MALL_COMPLETE_ORDER_SUCCESS
  };
};

export const mallCompleteOrderFail = () => {
  return {
    type: actionTypes.MALL_COMPLETE_ORDER_FAIL
  };
};
// END Complete Order
